var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"container"},[_c('mpx-image',{staticClass:"resouce",attrs:{"webp":"","src":(_vm.leftImg)},on:{"tap":_vm.goToNy}}),_c('mpx-image',{staticClass:"resouce",attrs:{"webp":"","src":(_vm.rightImg)},on:{"tap":_vm.goToDj}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }